import { Component } from "react";

/**
 * Tiny error boundary used around the catalog list/form so a renderer
 * exception (e.g. stale row + new meta) shows a recoverable message
 * instead of unmounting the whole page.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("AdminCatalog error boundary caught:", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="admin-error-boundary"
          className="rounded-xl border border-red-200 bg-red-50 p-6 text-sm text-red-900"
        >
          <p className="font-medium">Something went wrong rendering this view.</p>
          <p className="mt-1 text-xs text-red-700">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button
            onClick={this.reset}
            className="mt-3 rounded-md bg-red-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-red-800"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
